import axios from 'axios'

let aixoSysConfig = {
  baseURL: '',
  timeout: 180000,
  headers: {
    'Accept': 'application/json, text/plain, */*'
  }
}

let aixoSysApiConfig = {
  baseURL: 'http://120.76.183.152:8000/',
  timeout: 180000,
  headers: {
    'Accept': 'application/json, text/plain, */*'
  }
}

let aixoDataConfig = {
  baseURL: 'http://edata.reemii.cn/network',
  timeout: 180000,
  headers: {
    'content-type': 'application/json'
  }
}

export const axiosSysApi = axios.create(aixoSysConfig)

export const axiosSysApi2 = axios.create(aixoSysApiConfig)

export const axiosDataApi = axios.create(aixoDataConfig)



// WEBPACK FOOTER //
// ./src/axios_init.js